import React from 'react';
import InnerLayout from '../../../components/layouts/innerLayout';

const Cancel = () => {
    return (
        <InnerLayout module={"Payment Cancelled"}>
            <div className="h-full flex items-center justify-center bg-gradient-to-br from-red-100 via-white to-red-50 overflow-hidden">
                <div className="bg-white p-10 rounded-lg shadow-xl text-center relative">
                    {/* Animated Cancel Mark */}
                    <div className="flex items-center justify-center mb-6">
                        <div className="bg-red-500 rounded-full w-24 h-24 flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-12 h-12 animate-bounce-error"
                            >
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </div>
                    </div>

                    {/* Payment Canceled Message */}
                    <h1 className="text-3xl font-bold text-red-600 mb-4">
                        Payment Cancelled
                    </h1>
                    <p className="text-gray-700 text-lg">
                        Your subscription was not processed. You can try again anytime.
                    </p>

                    {/* Animated Confetti (Optional, adjust color for a less celebratory look) */}
                    <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
                        <div className="confetti absolute top-0 left-0 w-8 h-8 bg-red-400"></div>
                        <div className="confetti absolute top-0 right-0 w-8 h-8 bg-gray-300"></div>
                        <div className="confetti absolute bottom-0 left-0 w-8 h-8 bg-red-200"></div>
                        <div className="confetti absolute bottom-0 right-0 w-8 h-8 bg-gray-400"></div>
                    </div>
                </div>
            </div>
        </InnerLayout>
    );
};

export default Cancel;
